// extracted by mini-css-extract-plugin
export default {"MyLearningWidget":"MyLearningWidget_MyLearningWidget__Zq3zW","DomainsList":"MyLearningWidget_DomainsList__NPvs3"};